module.exports = __webpack_public_path__ + "static/AcorduriDinSuflet_LogoSmall.b05e98ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/AcorduriDinSuflet_LogoSmall.png
// module id = 572
// module chunks = 37581630142331